import Alpine from 'alpinejs';
import testsReport from './components/tests-report';
import courseAssignForm from './components/course-assign-form';
import reportDataTable from './components/report-data-table';
import popup from "./components/popup";
import certificate from "./components/certificate";
import quizSubmittedAction from "./lp-actions/quiz-submitted";
import quizzesList from "./components/quizzes-list";
import archiveQuizzesList from "./components/archive-quizzes-list";
import ultimateLightboxQuiz from "./modules/ultimate-lightbox-quiz";
import courseAssignedByMe from "./components/course-assigned-by-me";
import courseAssignedForMe from "./components/course-assigned-for-me";
import retakeCourse from "./components/retake-course";
import redLpAssign from "./components/assign-label";
import tree from "../admin/js/components/tree";
import { useHideElement } from '@scripts/hooks/use-hide-element.js';
import { useObserverUntilReady } from '@scripts/hooks/use-observer-until-ready.js';
import { AssignFormStore } from '@scripts/store/assign-form-store';
import { TestsReportStore } from '@scripts/store/tests-report-store';
import RozetkaCourseSelect from '@scripts/components/course-select.js';
import RozetkaAutoAssignDept from '@scripts/components/auto-assign-dept';
import RozetkaEmployeeSelect from '@scripts/components/rozetka-employee-select';
import RozetkaUserSelect from '@scripts/components/rozetka-user-select';
import initPartialRestHook from "./modules/partial-rest-hook";

document.addEventListener('alpine:init', () => {
    Alpine.store('popup', {
        redLpCertificatePopup: {
            show: false,
            config: {}
        }
    });

    Alpine.store('AssignFormStore', AssignFormStore);
    Alpine.store('TestsReportStore', TestsReportStore);

    Alpine.data('redLpPopup', popup);
    Alpine.data('redLpTestsReport', testsReport);
    Alpine.data('redLpCourseAssignForm', courseAssignForm);
    Alpine.data('redLpReportDataTable', reportDataTable);
    Alpine.data('redLpCertificate', certificate);
    Alpine.data('redLpQuizzesList', quizzesList);
    Alpine.data('redLpArchiveQuizzesList', archiveQuizzesList);
    Alpine.data('redLpCourseAssignedByMe', courseAssignedByMe);
    Alpine.data('redLpCourseAssignedForMe', courseAssignedForMe);
    Alpine.data('redLpRetakeCourse', retakeCourse);
    Alpine.data('redLpAssignLabel', redLpAssign);
    Alpine.data('CTree', tree);
    Alpine.data('RozetkaCourseSelect', RozetkaCourseSelect);
    Alpine.data('RozetkaAutoAssignDept', RozetkaAutoAssignDept);
    Alpine.data('RozetkaEmployeeSelect', RozetkaEmployeeSelect);
    Alpine.data('RozetkaUserSelect', RozetkaUserSelect);
});

Alpine.start()

initPartialRestHook();

document.addEventListener("DOMContentLoaded", async (event) => {
    const observer = new MutationObserver((mutations, obs) => {
        const gutenbergLightboxWrap = document.querySelector(".question-content .gutenberg-lightbox")
        if (gutenbergLightboxWrap && !gutenbergLightboxWrap.classList.contains('ewd-ulb-lightbox')) {
            ultimateLightboxQuiz()
        }
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })

    if (window.LP) {
        const { Hook } = LP

        Hook.addAction('quiz-started', data => {
            window.LP_QUIZ_SETTINGS.questions = data?.results?.questions;
        });

        Hook.addAction('quiz-submitted', quizSubmittedAction);

        useHideElement({
            selector: '.lp-button.start',
            condition: () => {
                const redHideRetake = window.LP_QUIZ_SETTINGS?.red_hide_retake;
                const currentResult = window.LP_QUIZ_SETTINGS?.results?.result;
                const currentPassingGrade = parseFloat(window.LP_QUIZ_SETTINGS?.passing_grade);

                return redHideRetake && (currentResult >= currentPassingGrade);
            },
        });

        useObserverUntilReady((_mutations) => {
            const quizIntroNode = document.querySelector('ul.quiz-intro');
            if (!quizIntroNode) return;

            let retakeCount = rozetka_learnpress_global?.learnpress?.quizRetakeCount;
            if (retakeCount === undefined || retakeCount === null) return;

            retakeCount = (retakeCount == -1) ? 'необмежена' : String(retakeCount);

            if (!quizIntroNode.querySelector('[data-retake-count]')) {
                const li = document.createElement('li');
                li.className = 'quiz-intro-item quiz-intro-item--retake-count';
                li.setAttribute('data-retake-count', '');

                const title = document.createElement('div');
                title.className = 'quiz-intro-item__title';
                title.textContent = 'Кількість спроб:';

                const val = document.createElement('span');
                val.className = 'quiz-intro-item__content';
                val.textContent = retakeCount;

                li.append(title, val);
                quizIntroNode.appendChild(li);
            }
        }, {}, 'ul.quiz-intro');
    }
});
